module.exports = __webpack_public_path__ + "media/customizations/lifeatkiawahriver/back-5e0b6b68535dad7589e1e51f0b4d9786.jpg";